import { defineMessages } from 'react-intl'
import { useFormatMessage } from 'src/providers/intl'
import { Button, Text } from 'src/Components'
import BaseCard from 'src/Components/homeSearch/ListingCard/BaseCard'
import image from './card-illustration.svg'
import styles from './ChromebotAd.module.scss'

export const CHROMEBOT_AD_MSG = defineMessages({
  imgAlt: {
    id: 'Listings.ad.imgAlt',
    defaultMessage: 'An image of homes',
  },
  header: {
    id: 'Listings.ad.header.full',
    defaultMessage: 'Find more Smart buys',
  },
  subheader: {
    id: 'Listings.ad.subheader.full.ad',
    defaultMessage:
      'Supercharge your house hunting with smart insights on other search sites',
  },
  button: {
    id: 'Listings.ad.subheader.full.ad.link',
    defaultMessage: 'Get Homebot for Chrome',
  },
})

export const ChromebotAd = () => {
  const intlFormat = useFormatMessage()

  return (
    <BaseCard>
      <BaseCard.Image image={image} alt={intlFormat(CHROMEBOT_AD_MSG.imgAlt)} />
      <BaseCard.Body>
        <div className={styles.wrapper}>
          <Text element='h2' size='m' variant='neutralCool' variantCount='900'>
            {intlFormat(CHROMEBOT_AD_MSG.header)}
          </Text>
          <Text element='div' size='s' variant='neutralCool' variantCount='700'>
            {intlFormat(CHROMEBOT_AD_MSG.subheader)}
          </Text>
          <Button title={intlFormat(CHROMEBOT_AD_MSG.button)}>
            {intlFormat(CHROMEBOT_AD_MSG.button)}
          </Button>
        </div>
      </BaseCard.Body>
    </BaseCard>
  )
}
